<template>
  <div class="cont cont_bg">
    <navs :lang="true" :saver="true" :mess="false" :bag="true" />
    <div class="cont_body">
      <div class="cont_title">
        <!-- <img src="@/assets/image/zfs_logo.png" alt=""> -->
        <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 22" role="presentation" focusable="false" width="190">
          <path fill-rule="nonzero" fill="#D44246"
            d="M81.95 7.43c3.59 0 5.77 2.33 6.02 5.1h-2.72a3.17 3.17 0 00-3.28-2.7c-2.2 0-3.66 1.86-3.66 4.88 0 3.08 1.47 4.87 3.7 4.87 1.75 0 2.9-.97 3.24-2.6H88c-.3 3-2.68 5.02-6.03 5.02-3.98 0-6.58-2.75-6.58-7.29 0-4.46 2.6-7.28 6.56-7.28zm-19.61 0c3.24 0 5.35 1.82 5.44 4.41h-2.69c-.16-1.36-1.15-2.22-2.75-2.22-1.55 0-2.59.77-2.59 1.89 0 .88.64 1.48 2.15 1.83l2.26.52c2.85.66 3.94 1.79 3.94 3.81 0 2.57-2.37 4.33-5.66 4.33-3.48 0-5.57-1.72-5.84-4.4h2.84c.26 1.48 1.25 2.2 3 2.2 1.72 0 2.78-.72 2.78-1.87 0-.91-.51-1.44-2.04-1.8l-2.26-.52c-2.65-.62-3.96-1.9-3.96-3.94 0-2.51 2.17-4.24 5.38-4.24zm-17 .26v8.53c0 2.14 1.01 3.28 2.99 3.28 2.06 0 3.3-1.44 3.3-3.63V7.7h2.87v14.04h-2.74v-2.37h-.07c-.77 1.68-2.19 2.63-4.32 2.63-3.03 0-4.88-2-4.88-5.21v-9.1h2.86zm-33.1-1.65h.3c.66.06 2.57.27 3.79 2.09-.1.08-2.27 1.33-2.24 3.98.02 3.16 2.75 4.21 2.77 4.24-.02.07-.43 1.49-1.42 2.95-.87 1.28-1.76 2.54-3.18 2.57-1.38.02-1.84-.82-3.42-.82-1.58 0-2.08.8-3.38.84-1.38.05-2.42-1.36-3.29-2.64C.4 16.65-.96 11.93.87 8.75c.9-1.6 2.53-2.6 4.28-2.63 1.35-.02 2.6.9 3.41.9.82 0 2.27-1.07 3.98-.97zm11.41-3.57l6.19 15.35h.1l6.18-15.35h3.44v19.26h-2.71V7.56h-.1L31 21.73h-2.2L23.02 7.56h-.1v14.17h-2.7V2.47h3.43zm49.52 5.22v14.04H70.3V7.7h2.86zM12.55 1a4.72 4.72 0 01-1.07 3.35c-.74.87-1.92 1.57-3.1 1.47a4.42 4.42 0 011.1-3.22A4.6 4.6 0 0112.56 1zm59.19 1.32c.91 0 1.64.74 1.64 1.66a1.65 1.65 0 11-3.3 0c0-.92.74-1.66 1.66-1.66z">
          </path>
        </svg>
        <p class="title">{{ $t('login.t02') }}</p> -->
        <img src="../../assets/image/Logo.svg" alt="">
      </div>
      <div class="cont_text">
        <p>{{ $t('login.t13') }}</p>
      </div>
      <div class="cont_bodyFrom">
        <div class="item">
          <van-field v-model="userName" :placeholder="$t('login.t03')" />
        </div>
        <div class="item">
          <van-field v-model="phone" :placeholder="$t('login.t07')" />
        </div>
        <div class="item">
          <van-field v-model="psd" type="password" :placeholder="$t('login.t04')" />
        </div>
        <div class="item">
          <van-field v-model="toPsd" type="password" :placeholder="$t('login.t08')" />
        </div>
        <div class="item">
          <van-field v-model="deposit_pwd" type="password" :placeholder="$t('user.t23')" />
        </div>
        <!-- <div class="item">
          <van-field v-model="code" :placeholder="$t('login.t09')" />
        </div> -->
        <div class="btn" @click="btnFun()">{{ $t('login.t10') }}</div>
        <div class="toRect">
          <span @click="$router.push('/login')">
            {{ $t('login.t05') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.cont {
  width: 100%;
  min-height: 100vh;
  position: relative;
  color: #fff;

  .cont_body {
    padding: 1rem 1.3rem;

    .cont_title {
      padding-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: .68rem;

      img {
        width: 5rem;
        // height: 2.6rem;
      }

      p.title {
        font-size: .64rem;
        font-weight: 700;
        margin-top: .3rem;
      }
    }

    .cont_text {
      padding: 0 .1rem;

      p {
        font-size: .30rem;
        color: #fff;
      }
    }

    .cont_bodyFrom {
      margin-top: 30px;

      .item {
        border: 1px solid #fff;
        border-radius: .1rem;
        margin-bottom: .42rem;
      }

      .btn {
        margin-top: .6rem;
        width: 100%;
        padding: .23rem .42rem;
        border-radius: .21rem;
        text-align: center;
        font-weight: 700;
        letter-spacing: 3px;
        color: #fff;
        background-color: #121212;
        font-size: .37rem;
      }

      .toRect {
        padding: .25rem 0;
        font-size: .37rem;
        margin-bottom: 70px;
        width: 100%;
        text-align: center;
        color: #fff;
      }
    }


  }
}

::v-deep {
  .van-cell {
    padding: 0.25rem 0.42rem;
    background-color: transparent !important;

    .van-field__control {
      color: #fff;
    }

    .van-field__body {
      input {
        font-size: .37rem;
      }
    }
  }

  .active {
    border: none !important;
  }
}
</style>
<script>
import { Toast } from "vant";
import navs from "@/components/navs.vue";

export default {
  components: { navs },
  data() {
    return {
      userName: '',
      phone: '',
      psd: '',
      toPsd: '',
      deposit_pwd: ''
      // code: this.$route.query.invite_code || ''
    }
  },
  created() {

  },
  methods: {
    btnFun() {
      if (this.userName === '') {
        Toast(this.$t('login.t03'));
        return;
      }
      if (this.phone === '') {
        Toast(this.$t('login.t07'));
        return;
      }
      if (this.psd === '') {
        Toast(this.$t('login.t04'));
        return;
      }
      if (this.toPsd === '') {
        Toast(this.$t('login.t11'));
        return;
      }
      if (this.psd !== this.toPsd) {
        Toast(this.$t('login.t15'));
        return;
      }
      if (this.deposit_pwd === '') {
        Toast(this.$t('user.t23'));
        return;
      }
      // if (this.code === '') {
      //   Toast(this.$t('login.t09'));
      //   return;
      // }
      this.$store.commit('SET_LOADING', true);
      const data = {
        user_name: this.userName,
        tel: this.phone,
        pwd: this.psd,
        deposit_pwd: this.deposit_pwd
        // invite_code: this.code
      }
      this.$http.getRegister(data).then(res => {
        if (res.code === 0) {
          Toast(this.$t('login.t16'));
          setTimeout(() => {
            this.$router.push('/login');
          }, 500)
        } else {
          Toast(res.info);
        }
      }).finally(() => {
        this.$store.commit('SET_LOADING', false);
      })
    }
  }
}
</script>
